var module = angular.module('octopusApp.shared');

module.factory('eventFormatter', function(octoUtil, octoDirectory) {
  return {
    format: function(e) {
      var message = e.Message;
      var isDelete = message.indexOf(' was deleted', message.length - ' was deleted'.length) !== -1;

      function htmlEncode(html) {
        return document.createElement('div')
          .appendChild(document.createTextNode(html))
          .parentNode
          .innerHTML;
      }

      var indexes = [];
      var references = e.MessageReferences;
      if (references && references.length > 0) {

        var refStart = references[0];
        if (refStart.StartIndex !== 0) {
          indexes.push({ ref: null, idx: 0 });
        }

        var lastRef = null;
        var referencesLength = references.length;
        for (var i = 0; i < referencesLength; i++) {
          var reference = references[i];

          if (!lastRef || lastRef.idx !== reference.StartIndex) {
            indexes.push({ ref: reference, idx: reference.StartIndex });
          }
          indexes.push({ ref: null, idx: reference.StartIndex + reference.Length });
          lastRef = reference;
        }

        var refEnd = references[references.length - 1];
        var endIndex = (refEnd.StartIndex + refEnd.Length);
        if (endIndex !== message.length) {
          indexes.push({ ref: null, idx: message.length });
        }

      } else {
        indexes.push({ ref: null, idx: 0 });
        indexes.push({ ref: null, idx: message.length });
      }

      var last = null;
      var parts = [];
      var indexesLen = indexes.length;
      for (var j = 0; j < indexesLen; j++) {
        var item = indexes[j];

        if (last) {
          parts.push({ ref: last.ref, msg: message.substring(last.idx, item.idx) });
        }

        last = item;
      }

      var encodedParts = _.map(parts, function(x) {

        var encMsg = htmlEncode(x.msg);
        if (x.ref) {
          var docId = x.ref.ReferencedDocumentId;
          var href = octoDirectory.linkTo(docId);

          if (docId.toLowerCase().indexOf("interruption")) {
            return "<a class='reference'  title='" + docId + "' href='" + href +  "'>" + encMsg + "</a>";
          } else {
            return encMsg;
          }

        } else {
          return encMsg;
        }
      });

      var result = _.reduce(encodedParts, function(aggregate, part) {
        return aggregate + part;
      }, "");

      return result;
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/services/event_formatter.js
// module id = 7461626438165788
// module chunks = 1